import React from "react";
import { Link } from "react-router-dom";
import { FiMapPin, FiPhone, FiMail } from "react-icons/fi";
import { useFormControl } from "./../hooks/useFormControl";

const STATE_INICIAL = {
  user_name: "",
  user_email: "",
  user_subject: "",
  message: "",
};

export default function Contact() {
  const { sended, spinner, errorForm, handleChange, handleSubmit } =
    useFormControl(STATE_INICIAL);

  return (
    <section className="contact" id="contact">
      <div className="section__container">
        <div className="section__header">
          <span className="section__tag">Let's talk</span>
          <h2 className="section__title">Get In Touch</h2>
        </div>
        <div className="contact__grid">
          <div className="contact__form-wrapper">
            <h3>Send a message</h3>
            <form
              className="contact__form"
              id="contact_form"
              onSubmit={handleSubmit}
            >
              {errorForm && (
                <div className="contact__alert contact__alert--error">
                  {errorForm}
                </div>
              )}
              {sended && (
                <div className="contact__alert contact__alert--success">
                  {sended}
                </div>
              )}
              <div className="contact__field">
                <label>Name</label>
                <input
                  type="text"
                  name="user_name"
                  placeholder="Your name"
                  onChange={handleChange}
                />
              </div>
              <div className="contact__field">
                <label>Email</label>
                <input
                  type="text"
                  name="user_email"
                  placeholder="your@email.com"
                  onChange={handleChange}
                />
              </div>
              <div className="contact__field">
                <label>Subject</label>
                <input
                  type="text"
                  name="user_subject"
                  placeholder="Subject"
                  onChange={handleChange}
                />
              </div>
              <div className="contact__field">
                <label>Message</label>
                <textarea
                  name="message"
                  placeholder="Write your message..."
                  onChange={handleChange}
                />
              </div>
              <div className="contact__submit-row">
                {spinner && <div className="contact__spinner"></div>}
                <button className="contact__submit" type="submit">
                  Send Message
                </button>
              </div>
              <p className="contact__privacy">
                Mit dem Absenden stimmen Sie der Verarbeitung Ihrer Daten gemäß
                unserer{" "}
                <Link className="contact__privacy-link" to="/datenschutz">
                  Datenschutzerklärung
                </Link>{" "}
                zu.
              </p>
            </form>
          </div>

          <div className="contact__info">
            <h3>Contact Details</h3>
            <p>
              Feel free to reach out for opportunities, collaborations, or just
              to say hello. I'm always open to a good conversation.
            </p>
            <div className="contact__info-items">
              <div className="contact__info-item">
                <div className="contact__info-item-icon">
                  <FiMapPin />
                </div>
                <div>
                  <h4>Location</h4>
                  <p>Augsburg, Germany</p>
                </div>
              </div>
              <div className="contact__info-item">
                <div className="contact__info-item-icon">
                  <FiPhone />
                </div>
                <div>
                  <h4>Phone</h4>
                  <p>+49 163 3833515</p>
                </div>
              </div>
              <div className="contact__info-item">
                <div className="contact__info-item-icon">
                  <FiMail />
                </div>
                <div>
                  <h4>Email</h4>
                  <p>alex.rodriguez.vera@hotmail.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
